import { render, staticRenderFns } from "./multipleChoiceSingle.vue?vue&type=template&id=43c403e8&scoped=true&"
import script from "./multipleChoiceSingle.vue?vue&type=script&lang=js&"
export * from "./multipleChoiceSingle.vue?vue&type=script&lang=js&"
import style0 from "./multipleChoiceSingle.vue?vue&type=style&index=0&id=43c403e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c403e8",
  null
  
)

export default component.exports